@if($loader.loaderState()){
  <div class="qform qform-loader-main" id="main_preloader" @fadeInOut>
    <div class="qform-loader qform-loader-open">
      <div class="qform-loader-box">
        <div class="qform-loader-box__dot"></div>
        <div class="qform-loader-box__dot"></div>
        <div class="qform-loader-box__dot"></div>
      </div>
    </div>
  </div>
}

